import i18n from '@/lib/i18n'

// 元はC#側のEnum
// Enumの値: i18n Resourceのキー
export const GnssSourceEnum = {
  Internal: 'GeneralMainSettingGnssSourceInternal',
  Usb: 'GeneralMainSettingGnssSourceUsb',
  Bluetooth: 'GeneralMainSettingGnssSourceBluetooth',
  Port: 'GeneralMainSettingGnssSourceTcpPort',
  DemoReplay: null,
  DemoVirtual: null,
  GPlus: 'GeneralMainSettingGnssSourceGPlus',
  TcpClient: null,
  AutoSteerGnssTest: null,
  GMini: 'GeneralMainSettingGnssSourceGMini',
  GMiniR: 'GeneralMainSettingGnssSourceGMiniR',
  G2: 'GeneralMainSettingGnssSourceG2',
  NtripClient: 'GeneralMainSettingGnssSourceNtripClient',
}

export default class GnssSource {
  static get UNKNOWN_SOURCE() {
    return '--'
  }

  static getLocalizedName(task) {
    if (task) {
      const gnssSource = task.gnssSource
      if (gnssSource) {
        let i18nKey = GnssSourceEnum[gnssSource]
        if (i18nKey) {
          let localizedName = null
          localizedName = i18n.navi(i18nKey)
          if (localizedName) {
            if (!localizedName.toString().startsWith('$vuetify')) {
              return localizedName
            }
          }
        }
      }
    }
    return GnssSource.UNKNOWN_SOURCE
  }
}
